// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"b522d43d","78":"2d2e01b8","344":"d1cb34b6","388":"63142443","525":"d72b6387","686":"9fed9bef","719":"d72b6387","735":"cfef792a","757":"87ee11fe","883":"d72b6387","963":"a46415bf"}[chunkId] + ".chunk.css";
};